export default __webpack_public_path__ + "static/media/arrow_left.160f6bee.svg";